import React from "react";
import { Link } from "react-router-dom";
import { BookOpen, FileText, Microscope, ArrowRight } from "lucide-react";

const RESOURCES = [
  { title: "The science of polyphenols", desc: "A primer on what polyphenols are, why concentration matters, and how they behave in the body.", icon: BookOpen, link: "/health-benefits" },
  { title: "How to read a COA", desc: "Make sense of LC-MS/MS reports, hydroxytyrosol values, and what 'EFSA-compliant' actually means.", icon: FileText, link: "/analysis" },
  { title: "Curated study library", desc: "A growing reference list of peer-reviewed papers on olive oil polyphenols, organised by health condition.", icon: Microscope, link: "/health-benefits" },
  { title: "The daily protocol", desc: "How to integrate Fountain of Youth into a daily routine for maximum benefit.", icon: BookOpen, link: "/faq" },
  { title: "Cooking with high-phenolic olive oil", desc: "Why heat matters, when to drizzle, and how to taste real freshness.", icon: FileText, link: "/faq" },
  { title: "Athletes' guide", desc: "Polyphenols and exercise: a science-led look at recovery and adaptation.", icon: Microscope, link: "/athletic-performance" },
];

export default function ResourcesPage() {
  return (
    <div className="bg-[#f4f0e6] text-[#3a3a32] min-h-screen">
      <section className="max-w-5xl mx-auto px-6 lg:px-10 pt-20 pb-12 text-center">
        <p className="text-xs tracking-[0.4em] uppercase text-[#4a7ba1] mb-4">Resources</p>
        <h1 className="text-4xl md:text-6xl font-light leading-tight" style={{ fontFamily: "'Cormorant Garamond', serif" }}>Learn deeper. Live longer.</h1>
        <p className="mt-6 text-[#5a5a52] max-w-2xl mx-auto leading-relaxed">A growing library of guides, study summaries, and practical protocols around high-phenolic olive oil.</p>
      </section>

      <section className="max-w-6xl mx-auto px-6 lg:px-10 pb-24 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {RESOURCES.map((r, i) => {
          const Icon = r.icon;
          return (
            <Link key={i} to={r.link} className="group block p-7 bg-[#ece6d6]/50 border border-[#4a7ba1]/15 rounded-sm hover:bg-[#ece6d6] hover:border-[#4a7ba1]/40 transition-all">
              <div className="w-12 h-12 rounded-full bg-[#4a7ba1]/15 grid place-items-center">
                <Icon size={22} className="text-[#4a7ba1]" strokeWidth={1.4} />
              </div>
              <h3 className="mt-5 text-xl text-[#1e3a52]" style={{ fontFamily: "'Cormorant Garamond', serif" }}>{r.title}</h3>
              <p className="mt-2 text-sm text-[#5a5a52] leading-relaxed">{r.desc}</p>
              <div className="mt-4 inline-flex items-center gap-1.5 text-sm text-[#4a7ba1] group-hover:gap-2.5 transition-all">Read more <ArrowRight size={14} /></div>
            </Link>
          );
        })}
      </section>
    </div>
  );
}
